module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user d-flex align-items-center justify-content-end pr-4"
  }, [(_vm.showNewBookingBtn) ? _c('router-link', {
    staticClass: "btn tertiary mr-3",
    attrs: {
      "to": "/reservation",
      "tag": "button"
    }
  }, [_vm._v("New Booking")]) : _vm._e(), _vm._v(" "), (_vm.showNotifications) ? _c('notifications-bell') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "person d-flex align-items-center pointer",
    on: {
      "click": _vm.openAccountDetails
    }
  }, [_c('span', {
    staticClass: "hidden-lg-down mx-3"
  }, [_vm._v(_vm._s(_vm.account.name))]), _vm._v(" "), (!_vm.account.avatar) ? _c('i', {
    staticClass: "fas fa-user-circle dark fa-2x mr-0"
  }) : _c('div', {
    staticClass: "avatarHolder radius-circle",
    style: ({
      'background-image': 'url(' + _vm.account.avatar + ')'
    })
  }), _vm._v(" "), _c('a', {
    staticClass: "pointer ml-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.triggerLogout.apply(null, arguments)
      }
    }
  }, [_vm._v("Logout")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1a72d169", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a72d169"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/User.vue
// module id = 2453
// module chunks = 0